import { render, staticRenderFns } from "./IconGebruikersgedrag.vue?vue&type=template&id=568b1e6e&scoped=true"
import script from "./IconGebruikersgedrag.vue?vue&type=script&lang=ts"
export * from "./IconGebruikersgedrag.vue?vue&type=script&lang=ts"
import style0 from "./IconGebruikersgedrag.vue?vue&type=style&index=0&id=568b1e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568b1e6e",
  null
  
)

export default component.exports